import { useEffect, useRef, useState } from "react";
import jwt_decode from "jwt-decode";
import format from 'format-number'
import { Alert, Autocomplete, Box, Button, Collapse, Grid, IconButton, InputAdornment, TextField, Tooltip } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import TipsAndUpdatesTwoToneIcon from '@mui/icons-material/TipsAndUpdatesTwoTone';
import PagosListado from "./PagosListado";
import { useNavigate } from "react-router-dom";
import striptags from "striptags";


//import NumberFormat from "react-number-format";

export default function Contrato(props) {
    const formulario = useRef();
    const token = sessionStorage.getItem('token')
    const [indice, setIndice] = useState(1)
    const decoded = jwt_decode(token);
    const idResponsable = decoded.id;
    const [anio, setAnio] = useState(null)
    const [partida, setPartida] = useState(null);
    const [pago, setPago] = useState({
        id: null,
        idSolicitud: null, idPartidaProyecto: null, partida: null, proyecto: null, monto: 0, comprobantes: []
    })
    const [contrato, setContrato] = useState({
        idSolicitud: null, clave: null, observaciones: null, justificacion: null, idPartidaProyecto: null, proyecto: null, monto: 0, comprobantes: []
    })

    const [errorMonto, setErrorMonto] = useState(false)
    const [helperTextMonto, setHelperTextMonto] = useState('')
    const [proyectos, setProyectos] = useState([])
    const [proyecto, setProyecto] = useState(null)
    const [fechas, setFechas] = useState(null)
    const [partidasProyecto, setPartidasProyecto] = useState([])
    const [partidas, setPartidas] = useState([])
    const [errorProyectoSinPartidas, setErrorProyectoSinPartidas] = useState(false)
    const [helperTextProyectoSinPartidas, setHelperTextProyectoSinPartidas] = useState('')

    const [montoComprometido, setMontoComprometido] = useState(0);
    const [pagos, setPagos] = useState([])
    const [solicitud, setSolicitud] = useState(null)
    const [documentos, setDocumentos] = useState([]);
    const [severity, setSeverity] = useState('error')

    const [sinConfiguracionFechas, setSinConfiguracionFechas] = useState(false)

    const [openMensaje, setOpenMensaje] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [pagosEliminados, setPagosEliminados] = useState([])
    const [limpiar, setLimpiar] = useState(false)
    const [monto, setMonto] = useState('')
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    const decodeHtmlEntities = (str) => {
        // Crea un contenedor de un elemento temporal para usar la propiedad innerHTML
        const txt = document.createElement("textarea");
        txt.innerHTML = str;
        return txt.value;
      };

    const handlePaste = (event) => {
        event.preventDefault();
        const html = event.clipboardData.getData("text/html");
        const plainText = event.clipboardData.getData("text/plain");
      
        // Si hay HTML, limpia las etiquetas; si no, usa texto plano
        let cleanText = html ? striptags(html) : plainText;

        cleanText = decodeHtmlEntities(cleanText);
      
        // Normaliza las viñetas y elimina caracteres raros
        cleanText = cleanText.replace(//g, "- ") // Reemplaza viñetas mal codificadas
          .replace(/§/g, "\n- ")
          .replace(/•|▪|■|◦|‣|⁃|◘|○|◙|◦|※|❖|◆|▶/g, "- ") // Diferentes viñetas de Word
          .replace(/\u2022/g, "- ") // Viñeta Unicode común
          .replace(/\u25AA/g, "- ") // Viñeta cuadrada pequeña
          .replace(/\u25AB/g, "- ") // Viñeta cuadrada
          .replace(/\u25CF/g, "- ") // Viñeta circular grande
          .replace(/\u25CB/g, "- ") // Viñeta circular pequeña
          .replace(/\t/g, " ") // Reemplaza tabulaciones por espacios
          .replace(/\s{2,}/g, " ") // Reduce múltiples espacios a uno solo
          .trim(); // Elimina espacios al inicio y final
      
          setContrato((prev) => ({
            ...prev,
            [event.target.name]: (prev[event.target.name] || "") + cleanText, 
          }));
      };

    const leerProyectos = async () => {
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/informeProyecto/proyectos/${idResponsable}/${false}/${sessionStorage.getItem('idEntidad')}`, { //Siempre es gestión por eso se pone false
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        if (res.status === 404) {
            //console.log('regresó 404 en Pago')
            return
        }
        else {
           
            const data = await res.json()
            //console.log(data)

            setProyectos(data)

            const idPlan = data[0].idPlan
            //console.log(`IDPLAN ${data[0].idPlan}`)
            const resPlan = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/planeacion/${idPlan}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                }
            }
            )
            const plan = await resPlan.json()
            //console.log(`ANIO ${plan.anio}`)
            setAnio(plan.anio)
            await cargarFechas(plan.anio)
            //console.log(`ANIO ${plan.anio}`)
        }

    }
    const { idSolicitud, setIdSolicitud, verificarDisponible } = props;

    useEffect(() => {

        (async () => {
            await leerProyectos();

            if (idSolicitud) {
                const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/contrato/solicitud/${idSolicitud}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": sessionStorage.getItem('token'),
                        "perfil": sessionStorage.getItem('perfil')
                    }
                })
                const solicitud = await res.json()

                if (res.status === 403) {
                    sessionStorage.clear();
                    window.location.replace(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_FRONTEND_PORT_LOGIN}/logout`)
                }


                //console.log(`solicitud ${JSON.stringify(solicitud)}`)

                setSolicitud(solicitud)
                setContrato(solicitud.contratos[0])

                //setPago({ ...pago })
                setPagos(solicitud.contratos[0].pagoContratos)


                /* const resProyecto = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/proyectosPlan/proyecto/${solicitud.idProyecto}`, {
                     method: "GET",
                     headers: {
                         "Content-Type": "application/json",
                         "x-access-token": sessionStorage.getItem('token'),
                         "perfil": sessionStorage.getItem('perfil')
                     }
                 })
                 const proyecto = await resProyecto.json()
                 setProyecto(proyecto)
                 const resPartidasProyecto = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidasProyecto/proyecto/${proyecto.id}`, {
                     method: "GET",
                     headers: {
                         "Content-Type": "application/json",
                         "x-access-token": sessionStorage.getItem('token'),
                         "perfil": sessionStorage.getItem('perfil')
                     }
                 })
 
                 const partidasProyectoLeidas = await resPartidasProyecto.json()
                 const partidasProyectoLectura = partidasProyectoLeidas.filter(partidasProyectoLeidas => Number(partidasProyectoLeidas.clave) < 5000000 || Number(partidasProyectoLeidas.clave) > 5999999)
                 //Mostrar sólo las no 5000
                 //console.log(`transferenciasDestino.clave ${JSON.stringify(transferenciasDestino[0].partida.clave)}`)
 
                 if (partidasProyectoLectura && partidasProyectoLectura.length > 0) {
                     setErrorProyectoSinPartidas(false)
                     setHelperTextProyectoSinPartidas('')
                     setPartidasProyecto(partidasProyectoLectura)
                 }
                 else {
                     setErrorProyectoSinPartidas(true)
                     setHelperTextProyectoSinPartidas('Este proyecto no tiene partidas')
                 }*/


            }

        })();
        // eslint-disable-next-line
    }, [limpiar]);

    const cargarFechas = async (anio) => {
        const entidad = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/entidad/${sessionStorage.getItem('idEntidad')}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        const entidadLeida = await entidad.json()

        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/configuracionFechas/configuracion/${anio}/${entidadLeida.idEntidadSuperior ? entidadLeida.idEntidadSuperior : entidadLeida.id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": sessionStorage.getItem('token'),
                "perfil": sessionStorage.getItem('perfil')
            }
        })
        const fechasLeidas = await res.json()
        if (res.status === 404) {
            setMensaje('Aún no se ha establecido la configuración de fechas, solicite a la Asistencia Administrativa que la registre')
            setOpenMensaje(true)
            setSinConfiguracionFechas(true)
        }

        setFechas(fechasLeidas)
        const fechaCierreAdquisiciones = new Date(fechasLeidas.cierreAdquisiciones)
        fechaCierreAdquisiciones.setDate(fechaCierreAdquisiciones.getDate() + 1);
    }

    const handleAgregarPago = () => {
        /* DESCOMENTAR CUANDO SE PONGA EL ARCHIVO if (!comprobante.documentos.get('PDF') && !comprobante.rutaPDF) {
            setErrorDocumentoPDF(true)
            setHelperTextDocumentoPDF('Debe seleccionar un archivo')
            return
        }
        if (!checkedComprobante && !comprobante.documentos.get('XML') && !comprobante.rutaXML) {
            setErrorDocumentoXML(true)
            setHelperTextDocumentoXML('Debe seleccionar un archivo')
            return
        }*/

        if (monto === null || monto === '' || Number(monto) === Number(0) || isNaN(monto)) {
            setErrorMonto(true)
            setHelperTextMonto('Especifique el monto')
            return
        }

        let pagoExiste
        //console.log(`pago.id ${pago.id}`)
        if (pago.id) {
            pagoExiste = pagos.filter(pagoListado => Number(pago.id) === Number(pagoListado.id))[0]
            pagoExiste.monto = monto
        }
        else {
            pagoExiste = { ...pago }
            pagoExiste.indice = indice
            setIndice(indice + 1)
        }

        pagoExiste.idPartidaProyecto = partida.idPartidaProyecto
        const partidaExiste = partidas.filter(partida => Number(pagoExiste.idPartidaProyecto) === Number(partida.idPartidaProyecto))
        if (partidaExiste && partidaExiste[0]) {
            partidaExiste[0].monto = (Number(partidaExiste[0].monto ? partidaExiste[0].monto : 0) + Number(pagoExiste.monto)).toFixed(2)
            //console.log(`partidaExiste[0].monto ${partidaExiste[0].monto}`)
        }
        else {
            partida.monto = Number(pagoExiste.monto)
            partidas.push({ ...partida })
        }
        //console.log(`partidas ${JSON.stringify(partidas)}`)
        /*console.log(`pagoExiste ${JSON.stringify(pagoExiste)} ${partida.idPartidaProyecto}`)
        if (pagoExiste && pagoExiste[0]) {
            pagoExiste[0].facturaPagos.push({ ...comprobante })
            pagoExiste[0].monto = (Number(pagoExiste[0].monto ? pagoExiste[0].monto : 0) + Number(comprobante.monto)).toFixed(2)
            if (pago.observaciones !== null && pago.observaciones !== '' && pagoExiste[0].observaciones !== pago.observaciones)
                pagoExiste[0].observaciones = pago.observaciones
        }
        else {
            if (!pago.facturaPagos)
                pago.facturaPagos = []
            pago.facturaPagos.push({ ...comprobante })
            pago.monto = (Number(pago.monto ? pago.monto : 0) + Number(comprobante.monto)).toFixed(2)
            pagos.push({ ...pago, idSolicitud })
            setPago({
                idSolicitud: null, observaciones: null, justificacion: null, idPartidaProyecto: null, monto: 0, comprobantes: []
            })
        }*/
        pagoExiste.idPartidaProyecto = partida.idPartidaProyecto
        pagoExiste.partida = `${partida.clave}-${partida.concepto}`
        pagoExiste.proyecto = `${proyecto.clave}-${proyecto.descripcion}`
        if (!pago.id) {
            pagos.push({ ...pagoExiste })
        }

        setErrorMonto(false);
        setHelperTextMonto('');

        //setPago({ id: null, indice: indice, monto: 0, documentos: new FormData(), idPartidaProyecto: null, partida: null, proyecto: null})
        //setProyecto(null)
        // setPartida(null)
        setMonto('')
        setPago({ ...pago, id: null })

        // formulario.current.reset()
        setPagos([...pagos])

        //console.log(`pagos ${JSON.stringify(pagos)}`)
    }

    const handleSubmit = async (e) => {
        setLoading(true)
        e.preventDefault()
        if (idSolicitud) {
            const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/contrato/solicitud/${idSolicitud}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                },
                body: JSON.stringify({
                    idSolicitante: idResponsable,
                    contrato,
                    pagos,
                    pagosEliminados,
                    idEntidad: sessionStorage.getItem('idEntidad')
                })
            })

            const data = await res.json()
            if (res.status === 200) {
                setSeverity('success')
                /*  setPartida(null)
  
                  const solicitud = data.solicitud
  
                  //setPago({ ...pago })
                  setPagos(solicitud.pagoPartidas)
                  setContrato({
                      idSolicitud: null, observaciones: null, justificacion: null
                  })
  
                  setPago({
                      id: null, idPartidaProyecto: null, partida: null, proyecto: null, monto: 0, comprobantes: []
                  })*/
                setLimpiar(true)
                setLoading(false)

            }
            else {
                setSeverity('error')
                setLoading(false)
            }
            if (data.message) {
                setOpenMensaje(true)
                setMensaje(data.message)
                return
            }
            else {
                setOpenMensaje(true)
                setMensaje("Se actualizó la solicitud.")
            }

        }
        else {
            const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/contrato`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                },
                body: JSON.stringify({
                    idSolicitante: idResponsable,
                    anio,
                    contrato,
                    pagos,
                    partidas,
                    idEntidad: sessionStorage.getItem('idEntidad')
                })
            })
            /*console.log(`${JSON.stringify({
                idSolicitante: idResponsable,
                anio,
                pagos
            })}`)*/
            const data = await res.json()
            if (res.status === 200) {
                setSeverity('success')
                /*setPartida(null)
                setPagos([])
                setContrato({
                    idSolicitud: null, observaciones: null, justificacion: null
                })

                setPago({
                    id: null, idSolicitud: null, idPartidaProyecto: null, partida: null, proyecto: null, monto: 0, comprobantes: []
                })*/
                setLimpiar(true)
                setLoading(false)
                setIdSolicitud(data.solicitud.id)
            }
            else {
                setSeverity('error')
                setLoading(false)
            }
            if (data.message) {
                setOpenMensaje(true)
                setMensaje(data.message)
                return
            }
            else {
                setOpenMensaje(true)
                setMensaje("Se registró la solicitud.")
            }
        }
    }
    return (
        <>
            <Grid container justifyContent='stretch' spacing={5}>
                <Grid item xs={12} sm={12}>
                    {pagos && pagos.length > 0 ? <PagosListado solicitud={solicitud} pagos={pagos} setPagos={setPagos} idSolicitud={idSolicitud} pagosEliminados={pagosEliminados} setPagosEliminados={setPagosEliminados} partidas={partidas} setPartidasProyecto={setPartidasProyecto} documentos={documentos} setDocumentos={setDocumentos} partida={partida} setPartida={setPartida} proyecto={proyecto} setProyecto={setProyecto} pago={pago} setPago={setPago} setLimpiar={setLimpiar} setMonto={setMonto}></PagosListado> : <></>}
                </Grid>
            </Grid>
            {solicitud && solicitud.estado !== 'ajustesJefe' && solicitud.estado !== 'ajustesAsistente' && solicitud.estado !== 'cancelada' && solicitud.estado !== 'concluida' ? <></> :
                <Grid container justifyContent='stretch' spacing={5} style={{ marginTop: 5 }}>
                    <Grid item xs={12} sm={12}>

                        <Grid container justifyContent='stretch' spacing={5}>

                            <Grid item xs={12} sm={4}>
                                <TextField name='clave' id='clave' focused label="Clave contrato" required onChange={(e) => {
                                    const valor = e.target.value
                                    setContrato({ ...contrato, clave: valor })
                                }} value={contrato.clave} sx={{ width: '100%' }}  onPaste={handlePaste}/>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Autocomplete
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    getOptionLabel={(option) => option.clave + '-' + option.descripcion}
                                    value={proyecto ? proyecto : null}
                                    onChange={async (event, newValue) => {
                                       // console.log(newValue)
                                        setProyecto(newValue)
                                        setPartida()

                                        if (newValue) {
                                            const res2 = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidasProyecto/proyecto/${newValue.id}`, {
                                                method: "GET",
                                                headers: {
                                                    "Content-Type": "application/json",
                                                    "x-access-token": sessionStorage.getItem('token'),
                                                    "perfil": sessionStorage.getItem('perfil')
                                                }
                                            })
                                            const partidasProyectoLectura = await res2.json()
                                            const partidasPago = partidasProyectoLectura.filter(partidasProyectoLectura => Number(partidasProyectoLectura.clave) < 5000000 || Number(partidasProyectoLectura.clave) > 5999999)
                                            //console.log(`partidasProyectoLectura ${JSON.stringify(partidasProyectoLectura)}`)


                                            if (partidasPago && partidasPago.length > 0) {
                                                setErrorProyectoSinPartidas(false)
                                                setHelperTextProyectoSinPartidas('')
                                                setPartidasProyecto(partidasPago)
                                            }
                                            else {
                                                setErrorProyectoSinPartidas(true)
                                                setHelperTextProyectoSinPartidas('Este proyecto no tiene partidas')
                                                setPartidasProyecto([])
                                            }
                                        }

                                    }}
                                    id="proyecto"
                                    name="proyecto"
                                    options={proyectos}
                                    sx={{ width: '100%' }}
                                    renderInput={(params) => <TextField {...params} label={`Proyecto`} focused helperText={helperTextProyectoSinPartidas} error={errorProyectoSinPartidas} required multiline />}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                {partidasProyecto ? partidasProyecto.length > 0 ?
                                    <Autocomplete
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        getOptionLabel={(option) => option.clave + '-' + option.concepto}
                                        value={partida ? partida : null}
                                        onChange={async (event, newValue) => {
                                            //console.log(`newValue ${JSON.stringify(newValue)}`)
                                            setPartida({ ...newValue, monto: 0 })
                                        }}
                                        id="partida"
                                        name="partida"
                                        options={partidasProyecto}
                                        sx={{ width: '100%' }}
                                        renderInput={(params) => <TextField {...params} label={`Partida`} focused required multiline />}
                                    />
                                    : <></> : <></>}
                            </Grid>

                            {partida ?
                                <>
                                    <Grid item xs={12}>
                                        <form ref={formulario}>
                                            <Grid container justifyContent='stretch' spacing={5} style={{ marginTop: 5 }}>
                                                <Grid item xs={12} sm={2}>
                                                    <TextField name='monto' id='monto' focused label={`Monto`} required onChange={(e) => {
                                                        let valor = e.target.value

                                                        valor = valor.replace(/-/g, ''); // Eliminar el signo negativo si se ingresa

                                                        const valorNumerico = valor.replace(/,/g, '')
                                                        const fechaPrioridad2 = new Date(fechas.activarMontosPrioridad2)
                                                        fechaPrioridad2.setDate(fechaPrioridad2.getDate() + 1);
                                                        partida.montoDescontado = isNaN(partida.montoDescontado) ? 0 : partida.montoDescontado
                                                        let montoDisponible = Number(partida.prioridad1Disponible)
                                                        //Aumenta al disponible el monto de los pagos eliminados que ya se encontraban en BD
                                                        pagosEliminados.map((pagoPartida) => {
                                                            let pagoEliminado
                                                            if (pagoPartida.idPartidaProyecto === partida.idPartidaProyecto && pagoPartida.id)
                                                                pagoEliminado = pagoPartida
                                                            if (pagoEliminado !== null) {
                                                                montoDisponible = Number(montoDisponible) + Number(pagoEliminado.monto ? pagoEliminado.monto : 0)
                                                            }
                                                        })

                                                        if (Date.now() >= Date.parse(fechaPrioridad2)) {
                                                            montoDisponible += Number(partida.prioridad2Disponible)
                                                        }
                                                        if (pago.id) {
                                                            const diferencia = Number(valorNumerico) - Number(pago.monto)

                                                            if (verificarDisponible() && Number(diferencia) > Number(montoDisponible)) {
                                                                setErrorMonto(true)
                                                                setHelperTextMonto(`No debe exceder el monto disponible de la partida ${format({ prefix: '$' })(Number(montoDisponible))}. Puede solicitar una transferencia a esta partida si así lo requiere.`)
                                                            }
                                                            else {
                                                                setErrorMonto(false)
                                                                setHelperTextMonto('')
                                                            }
                                                            setPago({ ...pago, 'monto': valorNumerico })
                                                            setMonto(valorNumerico)



                                                            /* poner después la lógica para descontar o liberar de la partida*/
                                                            /* if (Number(valorNumerico) > Number((Number(montoDisponible) + Number(montoComprometido)).toFixed(2))) {
                                                                 setErrorMonto(true)
                                                                 setHelperTextMonto(`No debe exceder el monto disponible de la partida ${format({ prefix: '$' })(Number((Number(montoDisponible) + Number(montoComprometido)).toFixed(2)))}. Puede solicitar una transferencia a esta partida si así lo requiere.`)
                                                             }
                                                             else {
                                                                 setErrorMonto(false)
                                                                 setHelperTextMonto('')
                                                             }
                                                             console.log(`ErrorMonto ${errorMonto} valor ${valorNumerico} partida.montoDisponible ${montoDisponible}`)*/
                                                        }
                                                        else {
                                                            let apartadoFacturas = Number(0)
                                                            let pagoNuevo = null
                                                            pagos.map((pagoPartida) => {
                                                                if (pagoPartida.idPartidaProyecto === partida.idPartidaProyecto && !pagoPartida.id)
                                                                    pagoNuevo = pagoPartida
                                                                if (pagoNuevo !== null) {
                                                                    apartadoFacturas = Number(apartadoFacturas) + Number(pagoNuevo.monto ? pagoNuevo.monto : 0)
                                                                }
                                                            })


                                                            montoDisponible = montoDisponible - apartadoFacturas

                                                            //console.log(`fecha prioridad 2 ${fechaPrioridad2}`)
                                                            setPago({ ...pago, 'monto': valorNumerico })
                                                            setMonto(valorNumerico)
                                                            if (verificarDisponible() && Number(valorNumerico) > Number((Number(montoDisponible) + Number(montoComprometido)).toFixed(2))) {
                                                                setErrorMonto(true)
                                                                setHelperTextMonto(`No debe exceder el monto disponible de la partida ${format({ prefix: '$' })(Number((Number(montoDisponible) + Number(montoComprometido)).toFixed(2)))}. Puede solicitar una transferencia a esta partida si así lo requiere.`)
                                                            }
                                                            else {
                                                                setErrorMonto(false)
                                                                setHelperTextMonto('')
                                                            }
                                                            //console.log(`ErrorMonto ${errorMonto} valor ${valorNumerico} partida.montoDisponible ${montoDisponible}`)
                                                        }
                                                    }}

                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    $
                                                                </InputAdornment>
                                                            )

                                                        }} value={monto} helperText={helperTextMonto} error={errorMonto} sx={{ width: '100%' }} />
                                                    <Tooltip title={<>Monto con IVA. En caso de tener retenciones monto total ANTES de retenciones</>} arrow><TipsAndUpdatesTwoToneIcon sx={{ color: 'orange' }} /></Tooltip>

                                                </Grid>
                                                <Grid item xs={12} sm={4}>
                                                    <Button variant='contained' color='primary' type='button' disabled={errorMonto || errorProyectoSinPartidas || sinConfiguracionFechas} onClick={handleAgregarPago}>
                                                        Guardar pago
                                                    </Button>
                                                    {/*<Button type='button' id='limpiar' onClick={() => { form.current.reset(); setErrorDocumentoPDF(false); setErrorMonto(false); setErrorDocumentoXML(false); setHelperTextMonto(''); setHelperTextDocumentoPDF(''); setHelperTextDocumentoXML(''); setComprobante({ monto: null, fecha: null, documentos: new FormData(), indice: 0, rutaPDF: null, rutaXML: null }) }}>Limpiar</Button>*/}
                                                </Grid>
                                                {/*<Grid item xs={12} sm={4}>
                                                    <Button type='button' id='limpiar' onClick={() => { formulario.current.reset();  setPago({ id: null, indice: indice, monto: '', documentos: new FormData(), idPartidaProyecto: null, partida: null, proyecto: null})}}>Limpiar</Button>
                                                </Grid>*/}
                                            </Grid>
                                        </form>
                                    </Grid>
                                </>
                                : <></>
                            }
                        </Grid>

                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <TextField label={`Observaciones contrato`} id='observaciones' name='observaciones' value={contrato.observaciones} focused multiline maxRows={5} sx={{ width: '100%' }}
                            onChange={(e) => {
                                const valor = e.target.value
                                setContrato({ ...contrato, [e.target.name]: valor })
                            }
                            } 
                            onPaste={handlePaste}/>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <TextField label={`Justificación contrato`} id='justificacion' name='justificacion' value={contrato.justificacion} focused multiline maxRows={5} sx={{ width: '100%' }}
                            onChange={(e) => {
                                const valor = e.target.value
                                setContrato({ ...contrato, [e.target.name]: valor })
                            }
                            } onPaste={handlePaste} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Button variant='contained' color="success" type='button' disabled={(((pagos && pagos.length === 0)) && !idSolicitud) || loading || severity === 'success'} onClick={handleSubmit}>
                            Guardar
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={6}>                        
                        <Button color="primary" type='button' variant='contained'                       
                           onClick={() => { navigate(-1) }}
                        >                            
                            Cerrar
                        </Button>
                    </Grid>

                </Grid>
            }

            <Box sx={{ width: '100%' }}>
                <Collapse in={openMensaje}>
                    <Alert severity={severity}
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setOpenMensaje(false);
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                        style={{ marginTop: 30 }}
                    >
                        {mensaje}
                    </Alert>
                </Collapse>
            </Box>
        </>
    )
}